<template>
  <div class="balance-detail">
    <div class="balance-log" v-for="item in logList" :key="item.id">
      <div class="balance-log-row1">
        <span class="change-type">{{ formatType(item.change_type) }}</span>
        <router-link v-if="isMerchant && item.business_order_id" class="log-info log-info-link" :to="getOrderLink(item)"
          target="_blank">{{ formatInfo(item) }}</router-link>
        <span v-else class="log-info log-info-text">{{ formatInfo(item) }}</span>
        <span class="amount" :class="{ 'amount-reverse': isReverse(item) }">{{ isReverse(item) ? '-' : '+' }} {{
          formatAmount(item.amount) }}</span>
      </div>
      <div class="balance-log-row2">
        <span class="date">{{ formatBalanceDate(item.dt_created) }}</span>
        <span class="balance">
          <span class="balance-label">{{ balanceLabel }}</span>
          {{ formatBalance(item.current_balance) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { BalanceChangeType, isInfinite } from '@/plugins/balance'
import { formatCurrency, formatPrice } from '@/plugins/price'
import { EquityPattern } from '@/plugins/payment'
import { formatDate, formatFullDate } from '@/plugins/datefmt'

export default {
  props: {
    equity: {
      type: Object,
      required: false,
    },
    balanceLogList: {
      type: Array,
      required: false,
    },
    isMerchant: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      balance_logs: [],
    }
  },
  computed: {
    title() {
      return this.equity?.name ?? '详情'
    },
    logList() {
      return this.balanceLogList || []
    },
    isSubscription() {
      return this.equity?.pattern !== EquityPattern.CONSUMABLE
    },
    balanceLabel() {
      return this.isSubscription ? '可用至' : '余额'
    },
  },
  methods: {
    isReverse(item) {
      return BalanceChangeType.isReverse(item.change_type)
    },
    formatType(change_type) {
      const typeMap = {
        [BalanceChangeType.INITIAL]: '试用',
        [BalanceChangeType.REDEEM_CODE]: '兑换',
        [BalanceChangeType.PAYMENT_SUBMIT]: '购买',
        [BalanceChangeType.PAYMENT_CONFIRM]: '购买',
        [BalanceChangeType.PAYMENT_REVERT]: '撤销',
        [BalanceChangeType.PAYMENT_REFUND]: '退款',
        [BalanceChangeType.CONSUMABLE_EXPENSE]: '消费',
        [BalanceChangeType.CONSUMABLE_INCOME]: '收入',
        [BalanceChangeType.TASK_INCREASE]: '增加',
        [BalanceChangeType.TASK_DECREASE]: '减少',
        [BalanceChangeType.TRANSFER_UPGRADE]: '转换',
      }
      return _.defaultTo(typeMap[change_type], change_type)
    },
    formatInfo(item) {
      if (item.change_type === BalanceChangeType.INITIAL) {
        return ''
      }
      if (item.change_type === BalanceChangeType.REDEEM_CODE) {
        return item.title || item.redeem_code_value
      }
      let title = item.title || `${item.business_order_id}`
      if (!item.currency || _.isNil(item.total_price)) {
        return title
      }
      let price = formatPrice(item.total_price, item.currency)
      let currencyText = formatCurrency(item.currency)
      return `${title} ${price} ${currencyText}`
    },
    formatAmount(amount) {
      if (this.isSubscription) {
        if (isInfinite(amount)) {
          return '永久'
        }
        let days = amount / (24 * 60 * 60)
        return `${days.toFixed(0)} 天`
      } else {
        if (isInfinite(amount)) {
          return '无限'
        }
        return String(amount) + ' 积分'
      }
    },
    formatBalance(balance) {
      if (this.isSubscription) {
        if (isInfinite(balance)) {
          return '永久'
        }
        return formatDate(balance * 1000)
      } else {
        if (isInfinite(balance)) {
          return '无限'
        }
        return String(balance)
      }
    },
    formatBalanceDate(date) {
      return formatFullDate(date)
    },
    getOrderLink(item) {
      return {
        path: '/dash/payment-order-detail',
        query: {
          business_order_id: item.business_order_id,
        },
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.balance-log {
  height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.5;

  .change-type {
    width: 64px;
    font-size: 16px;
    font-weight: bold;
  }

  .log-info {
    flex: 1;
    color: @antTextSemi;
  }

  .amount {
    color: @antGreen;
    font-size: 16px;
    font-weight: bold;
  }

  .amount-reverse {
    color: @antTextSemi;
  }

  .date,
  .balance {
    font-size: 12px;
    color: @antTextLight;
  }
}

.balance-log-row1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.balance-log-row2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
